import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/index'
import schedule from '@/pages/schedule/index'
import exhibitor from '@/pages/exhibitor/index'
import newsCenter from '@/pages/newsCenter/index'
import mediaCenter from '@/pages/mediaCenter/index'
import mediaApply from '@/pages/mediaCenter/mediaApply'
import buyTicket from '@/pages/buyTicket/index'
import aboutUs from '@/pages/aboutUs/index'
import activity from '@/pages/activity/index'
import history from '@/pages/history/index'
import friendlyLink from '@/pages/friendlyLink/index'
import foreignMedia from '@/pages/mediaCenter/foreignMedia'
import foreignMediaMain from '@/pages/mediaCenter/foreignMediaMain'
import findTicket from '../pages/mediaCenter/findTicket.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: schedule
    },
    {
      path: '/exhibitor',
      name: 'exhibitor',
      component: exhibitor
    },
    {
      path: '/newsCenter',
      name: 'newsCenter',
      component: newsCenter
    },
    {
      path: '/mediaCenter',
      name: 'mediaCenter',
      component: mediaCenter
    },
    {
      path: '/buyTicket',
      name: 'buyTicket',
      component: buyTicket
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/history',
      name: 'history',
      component: history
    },
    {
      path: '/mediaApply',
      name: 'mediaApply',
      component: mediaApply,
      meta:{hideHeader:true}
    },
    {
      path: '/friendlyLink',
      name: 'friendlyLink',
      component: friendlyLink
    },
    // {
    //   path:'/foreignMediaMain',
    //   name:'foreignMediaMain',
    //   meta:{hideHeader:true},
    //   component:foreignMediaMain,
    // },
    // {
    //   path:'/foreignMedia',
    //   name:'foreignMedia',
    //   meta:{hideHeader:true},
    //   component:foreignMedia,
    // },
    {
      path:'/findTicket',
      name:'findTicket',
      meta:{hideHeader:true},
      component:findTicket,
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})





// WEBPACK FOOTER //
// ./src/router/index.js